<template>
  <div class="login-page">
    <el-card class="login-card" shadow="hover">
      <div slot="header" class="title">ACAA 证书管理后台</div>
      <el-form ref="form" :model="form" :rules="rules" label-width="0">
        <el-form-item prop="username">
          <el-input v-model.trim="form.username" placeholder="用户名" clearable />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model.trim="form.password"
            type="password"
            placeholder="密码"
            show-password
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width: 100%" @click="submit">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { loginApi, meApi } from '../api/auth'
import store from '../store'

export default {
  name: 'AccaLogin',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const loginRes = await loginApi({
            username: this.form.username,
            password: this.form.password
          })
          const d = loginRes.data || {}
          store.commit('setToken', d.token || '')
          const meRes = await meApi()
          store.commit('setUserInfo', meRes.data)
          this.$message.success('登录成功')
          this.$router.replace('/')
        } catch (e) {
          this.$message.error(e.message || '登录失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(160deg, #1f2d3d 0%, #304156 40%, #f5f7fa 40%);
}

.login-card {
  width: 100%;
  max-width: 400px;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}
</style>
